let Backbone = window.Backbone;

export default Backbone.Model.extend({
  defaults: {
    taxonomy: null,
    slug: '',
    name: '',
    selected: false
  }
});


// WEBPACK FOOTER //
// ./assets/src/javascripts/userContent/filters/Filter.model.js